export default __webpack_public_path__ + "static/media/fishMascot.eb9d0ef4.png";